export const taskRelationsKeys = {
  related: (workspaceId: string, taskId: string) =>
    ['task-relations', 'related', workspaceId, taskId] as const,
  siblings: (workspaceId: string, taskId: string, workflowId: string) =>
    ['task-relations', 'siblings', workspaceId, taskId, workflowId] as const,
  /** A task's own depth-1 relations, with their edge ids (068, research D6). */
  direct: (workspaceId: string, taskId: string) =>
    ['task-relations', 'direct', workspaceId, taskId] as const,
};
